import moment from "moment";
import { put, call, takeLatest, all, select } from "redux-saga/effects";

import { notification } from "infrastructure/notification";
import { securityMessages } from "ui/screens/security/security.localization";

import { roleMembersHistoryActions } from "./RoleMembersHistory.actions";
import { getRoleMembersHistory } from "./RoleMembersHistory.api";
import { IRoleMembersHistoryResponse, IRoleMembersHistoryRequest } from "./RoleMembersHistory.api.types";
import { IRoleAssignmentEvent, IRoleMembersHistoryState } from "./RoleMembersHistory.state";

function* loadRoleMembersHistoryExecute() {
  try {
    const state: IRoleMembersHistoryState = yield select((state: { roleMembersHistory: IRoleMembersHistoryState }) => state.roleMembersHistory);

    const request: IRoleMembersHistoryRequest = {
      roleId: state.initData.securityRoleId,
      tenantId: state.initData.tenantId,
      accountId: state.filter?.account?.accountId,
      dateFrom: state.filter && state.filter.dateRange && moment(state.filter.dateRange.dateFrom).format(),
      dateTo:
        state.filter &&
        state.filter.dateRange &&
        moment(state.filter?.dateRange?.dateTo)
          .add(1, "d")
          .format()
    };

    const roleMembersHistoryResponse: IRoleMembersHistoryResponse[] = yield call(getRoleMembersHistory, request);

    const roleAssignmentEvents = roleMembersHistoryResponse.map<IRoleAssignmentEvent>(e => ({
      account: {
        accountId: e.accountId,
        accountName: e.accountName
      },
      author: {
        accountId: e.author,
        accountName: e.authorName
      },
      action: e.action,
      committedTime: e.committedTime
    }));

    yield put(roleMembersHistoryActions.loadRoleMembersHistoryCompleted(roleAssignmentEvents));
  } catch (e) {
    yield put(roleMembersHistoryActions.loadRoleMembersHistoryFailed(notification.error(e).useMessageId(securityMessages.error("loadRoleMembersHistoryFailed"))));
  }
}

function* applyFilterExecute() {
  yield put(roleMembersHistoryActions.loadRoleMembersHistory());
}

export function* roleMembersHistorySaga() {
  yield all([
    yield takeLatest(roleMembersHistoryActions.loadRoleMembersHistory.toString(), loadRoleMembersHistoryExecute),
    yield takeLatest(roleMembersHistoryActions.applyFilter.toString(), applyFilterExecute)
  ]);
}
